import { DataFetchProvider } from '@betterment/js-runtime';
import { SentryErrorBoundary } from '@betterment/shared-components';
import { StyleClosetThemeProvider } from '@betterment/style-closet-react';
import { Controller } from '@hotwired/stimulus';
import { withProfiler } from '@sentry/react';
import { Root, createRoot } from 'react-dom/client';

import { InstitutionalApp } from '../apps/InstitutionalApp';

const App = withProfiler(InstitutionalApp, { name: 'Institutional' });

export default class extends Controller {
  root?: Root;

  connect() {
    this.root ??= createRoot(this.element);
    this.root.render(
      <SentryErrorBoundary fallbackType="full">
        <StyleClosetThemeProvider theme="default">
          <DataFetchProvider>
            <App {...this.initialProps} />
          </DataFetchProvider>
        </StyleClosetThemeProvider>
      </SentryErrorBoundary>
    );
  }

  disconnect() {
    this.root?.unmount();
    this.root = undefined;
  }

  get initialProps() {
    return JSON.parse(this.data.get('initial-props') || '{}') as Record<string, unknown>;
  }
}
